<template>
	<StandardModal data-context="cancel-confirm modal" @modal-close="close">
		<template #title> Are you sure? </template>
		<template #content> Your progress will not be saved, but you can restart at any time. </template>
		<template #button-section>
			<BaseButtonGroup>
				<template #secondary>
					<BaseLinkButton data-test="cancel" classes="button button-outline" @click="close"
						>Never mind</BaseLinkButton
					>
				</template>
				<template #primary>
					<BaseLink
						data-test="confirm"
						classes="button button-default"
						:link="{ text: 'Yes, exit', router: redirect }"
						@click="close"
					/>
				</template>
			</BaseButtonGroup>
		</template>
	</StandardModal>
</template>

<script setup lang="ts">
import StandardModal from '@components/modals/standard-modal.vue';

interface Props {
	redirect?: string;
}
withDefaults(defineProps<Props>(), {
	redirect: 'home'
});

interface Emits {
	(e: 'modal-close'): void;
}
const emit = defineEmits<Emits>();

function close(): void {
	emit('modal-close');
}
</script>
